const getCardPosition = (index: number) => {
    return index + 1
}

export default getCardPosition
